export default __webpack_public_path__ + "static/media/grid_pattern.11b7f115.svg";